import { AuthContextType } from "./types";
import { useContext } from "react";
import { AuthContext } from "./context";

export function useAuth(): AuthContextType {
    return useContext(AuthContext)
}